import { useTranslation } from 'react-i18next';
import styles from './PhotoCredit.module.css';

interface PhotoCreditProps {
    source: string;
    href?: string;
}

export default function PhotoCredit({ source, href }: PhotoCreditProps) {
    const { t } = useTranslation();
    const label = t('project.photoCredit', { source });

    if (!href) {
        return <span className={styles.credit}>{label}</span>;
    }

    return (
        <a href={href} className={styles.credit} target="_blank" rel="noopener noreferrer">
            {label}
            <span className="visually-hidden">{t('a11y.opensInNewTab')}</span>
        </a>
    );
}
